var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-divider-circle';
                    var viewUrl = 'gfx/sprite.svg#view-icon-divider-circle';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 2 2',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };